import { TipoCacheRespuestaEnum } from "@shared/enums";
import { Respuesta, RespuestaExtra } from "../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { ProcesoDatos } from "../../../proceso-datos/ProcesoDatos";
import { ItemPreguntaDTO } from "@DTOS";

export abstract class CacheRespuestas {
    abstract obtenerRespuestas(tipoCacheRespuesta: TipoCacheRespuestaEnum): Respuesta[];
    abstract obtenerRespuestaProcesada(itemId: number): RespuestaExtra;
    abstract existenRespuestas(tipoCacheRespuesta: TipoCacheRespuestaEnum): boolean;
    abstract existenRespuestaProcesada(itemId: number): boolean;
    abstract limpiar();
    abstract guardarDesdeProcesoDatos(procesoDatos: ProcesoDatos): void;
    abstract obtenerUsuariosPorItem(item: ItemPreguntaDTO): Set<number>;
}
